import { createLucideIcon } from "lucide-react";

export const Lock = createLucideIcon(
    "Lock",
    [
        [
            "path",
            {
                d: "M12 10.5V11.25C12.8807 11.25 13.6792 11.2681 14.4647 11.3026L14.4977 10.5534L14.5307 9.8041C13.7225 9.7685 12.9021 9.75 12 9.75V10.5Z",
                key: "piwr1p",
            },
        ],
        [
            "path",
            {
                d: "M12 17.5V16.75C11.1193 16.75 10.3208 16.7319 9.5353 16.6974L9.5023 17.4466L9.4693 18.1959C10.2775 18.2315 11.0979 18.25 12 18.25V17.5Z",
                key: "5mfejg",
            },
        ],
        [
            "path",
            {
                d: "M13.75 10.5C13.75 10.9142 14.0858 11.25 14.5 11.25C14.9142 11.25 15.25 10.9142 15.25 10.5H14.5H13.75Z",
                key: "galoap",
            },
        ],
        [
            "path",
            {
                d: "M14.4977 10.5534L14.5307 9.8041L14.4977 10.5534Z",
                key: "c26tb1",
            },
        ],
        [
            "path",
            {
                d: "M14.4977 17.4466L14.4647 16.6974C13.6792 16.7319 12.8807 16.75 12 16.75V17.5V18.25C12.9021 18.25 13.7225 18.2315 14.5307 18.1959L14.4977 17.4466Z",
                key: "f7xyhj",
            },
        ],
        [
            "path",
            {
                d: "M14.4977 17.4466L14.5307 18.1959C15.828 18.1388 16.9137 17.1732 17.092 15.9055L16.3494 15.801L15.6067 15.6966C15.532 16.2275 15.0614 16.6711 14.4647 16.6974L14.4977 17.4466Z",
                key: "13i0xu",
            },
        ],
        [
            "path",
            {
                d: "M14.4977 17.4466L14.5307 18.1959L14.4977 17.4466Z",
                key: "1helsn",
            },
        ],
        [
            "path",
            {
                d: "M14.5 9H13.75V10.5H14.5H15.25V9H14.5Z",
                key: "zkwotm",
            },
        ],
        [
            "path",
            {
                d: "M14.5 9H15.25C15.25 7.2051 13.7949 5.75 12 5.75V6.5V7.25C12.9665 7.25 13.75 8.0335 13.75 9H14.5Z",
                key: "7b1tj5",
            },
        ],
        [
            "path",
            {
                d: "M15.8132 21.5C17.9129 21.3959 19.2221 21.0846 20.1534 20.1534C21.0846 19.2221 21.3959 17.9129 21.5 15.8132",
                key: "jnx853",
            },
        ],
        [
            "path",
            {
                d: "M16.3494 12.199L17.092 12.0945C16.9137 10.8268 15.828 9.8612 14.5307 9.8041L14.4977 10.5534L14.4647 11.3026C15.0614 11.3289 15.532 11.7725 15.6067 12.3034L16.3494 12.199Z",
                key: "r5qp8e",
            },
        ],
        [
            "path",
            {
                d: "M16.3494 12.199L17.092 12.0945L16.3494 12.199Z",
                key: "y9mvrv",
            },
        ],
        [
            "path",
            {
                d: "M16.3494 15.801L15.6067 15.6966L16.3494 15.801Z",
                key: "1rvgut",
            },
        ],
        [
            "path",
            {
                d: "M16.3494 15.801L17.092 15.9055C17.1761 15.3078 17.25 14.6654 17.25 14H16.5H15.75C15.75 14.5598 15.6877 15.1203 15.6067 15.6966L16.3494 15.801Z",
                key: "n2j619",
            },
        ],
        [
            "path",
            {
                d: "M16.5 14H17.25C17.25 13.3346 17.1761 12.6922 17.092 12.0945L16.3494 12.199L15.6067 12.3034C15.6877 12.8797 15.75 13.4402 15.75 14H16.5Z",
                key: "vgg5b7",
            },
        ],
        [
            "path",
            {
                d: "M2.5 8.1868C2.6041 6.087 2.9154 4.7779 3.8466 3.8466C4.7779 2.9154 6.087 2.6041 8.1868 2.5",
                key: "rvjgyf",
            },
        ],
        [
            "path",
            {
                d: "M21.5 8.1868C21.3959 6.087 21.0846 4.7779 20.1534 3.8466C19.2221 2.9154 17.9129 2.6041 15.8132 2.5",
                key: "ahxqz4",
            },
        ],
        [
            "path",
            {
                d: "M7.5 14H6.75C6.75 14.6654 6.8239 15.3078 6.908 15.9055L7.6506 15.801L8.3933 15.6966C8.3123 15.1203 8.25 14.5598 8.25 14H7.5Z",
                key: "g49g5s",
            },
        ],
        [
            "path",
            {
                d: "M7.6506 12.199L6.908 12.0945C6.8239 12.6922 6.75 13.3346 6.75 14H7.5H8.25C8.25 13.4402 8.3123 12.8797 8.3933 12.3034L7.6506 12.199Z",
                key: "f6ma2m",
            },
        ],
        [
            "path",
            {
                d: "M7.6506 12.199L8.3933 12.3034L7.6506 12.199Z",
                key: "1a2mmf",
            },
        ],
        [
            "path",
            {
                d: "M7.6506 15.801L8.3933 15.6966L7.6506 15.801Z",
                key: "m5z72s",
            },
        ],
        [
            "path",
            {
                d: "M8.1868 21.5C6.087 21.3959 4.7779 21.0846 3.8466 20.1534C2.9154 19.2221 2.6041 17.9129 2.5 15.8132",
                key: "18zy62",
            },
        ],
        [
            "path",
            {
                d: "M8.75 10.5C8.75 10.9142 9.0858 11.25 9.5 11.25C9.9142 11.25 10.25 10.9142 10.25 10.5H9.5H8.75Z",
                key: "1klau1",
            },
        ],
        [
            "path",
            {
                d: "M9.5 10.5H10.25V9H9.5H8.75V10.5H9.5Z",
                key: "1kutpi",
            },
        ],
        [
            "path",
            {
                d: "M9.5 9H10.25C10.25 8.0335 11.0335 7.25 12 7.25V6.5V5.75C10.2051 5.75 8.75 7.2051 8.75 9H9.5Z",
                key: "1lfiyk",
            },
        ],
        [
            "path",
            {
                d: "M9.5023 10.5534L9.4693 9.8041C8.1721 9.8612 7.0863 10.8268 6.908 12.0945L7.6506 12.199L8.3933 12.3034C8.468 11.7725 8.9386 11.3289 9.5353 11.3026L9.5023 10.5534Z",
                key: "4iyz7k",
            },
        ],
        [
            "path",
            {
                d: "M9.5023 10.5534L9.5353 11.3026C10.3208 11.2681 11.1193 11.25 12 11.25V10.5V9.75C11.0979 9.75 10.2775 9.7685 9.4693 9.8041L9.5023 10.5534Z",
                key: "1r6o80",
            },
        ],
        [
            "path",
            {
                d: "M9.5023 10.5534L9.5353 11.3026L9.5023 10.5534Z",
                key: "1czgup",
            },
        ],
        [
            "path",
            {
                d: "M9.5023 17.4466L9.4693 18.1959L9.5023 17.4466Z",
                key: "1sj6cc",
            },
        ],
        [
            "path",
            {
                d: "M9.5023 17.4466L9.5353 16.6974C8.9386 16.6711 8.468 16.2275 8.3933 15.6966L7.6506 15.801L6.908 15.9055C7.0863 17.1732 8.1721 18.1388 9.4693 18.1959L9.5023 17.4466Z",
                key: "32hjrj",
            },
        ],
    ],
);
